import { useQuery } from '@tanstack/react-query';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { getUserPointApi } from '@flipster/apis/v1/user';
import { authBunja } from '@flipster/features/src/shared/auth/state';

export const useUserPoint = () => {
  const { isCookieLoggedInAtom } = useBunja(authBunja);
  const isCookieLoggedIn = useAtomValue(isCookieLoggedInAtom);

  return useQuery({
    queryKey: ['getUserPointApi', isCookieLoggedIn],
    queryFn: getUserPointApi,
    select: (res) => res.data,
    enabled: isCookieLoggedIn,
  });
};
